import { useEffect, useState } from "react";
import { PageHeaderUi, NewBtn } from "../../ui";
import { PeriodoContableModal } from "./modal/PeriodoContableModal";
import { PeriodoContableTable } from "./PeriodoContableTable";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { periodoContableStartLoad } from "../../../actions";

export const PeriodoContableList = () => {
  const [OpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const { periodosContables, loading } = useSelector(
    (state) => state.inventario,
  );
  useEffect(() => {
    dispatch(periodoContableStartLoad());
  }, []);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  return (
    <PageHeaderUi
      title="Periodos contables"
      subTitle="Listado"
      extra={[<NewBtn key="nuevo" onClick={handleOpenModal} />]}
    >
      <Row>
        <Col sm={32} md={32} xl={24}>
          <PeriodoContableTable
            data={periodosContables}
            loading={loading}
            handleOpenModal={handleOpenModal}
          />
        </Col>
      </Row>
      <PeriodoContableModal
        open={OpenModal}
        handleCloseModal={handleCloseModal}
      />
    </PageHeaderUi>
  );
};
